export interface PointOfContact {
	userId: string;
	name: string;
	email: string;
}

interface LEADetail {
	logtoId: string;
	numberOfUsers: number;
	emailDomain: string;
	pointsOfContact: PointOfContact[];
	notes: string;
	useCases: Record<string, { rrd: number }>[];
	createdAt: number;
	onboarded: boolean;
	featureFlags: string[];
}

export type LEADetails = Record<string, LEADetail>;

export interface MetricsFilters {
	fromDate?: number;
	toDate?: number;
	userName?: string;
	userTeam?: string;
	caseId?: string;
	fileName?: string;
	wordListName?: string;
	uploadComplete?: boolean;
	processingComplete?: boolean;
}

interface MetricsComponents {
	name: string;
	componentType: 'string' | 'number' | 'date' | 'boolean' | 'autocomplete';
}

export const MetricsFilterMappings: Record<keyof MetricsFilters, MetricsComponents> = {
	fromDate: {
		name: 'Date From',
		componentType: 'date',
	},
	toDate: {
		name: 'Date To',
		componentType: 'date',
	},
	userName: {
		name: 'User Name',
		componentType: 'autocomplete',
	},
	userTeam: {
		name: 'User Team',
		componentType: 'autocomplete',
	},
	caseId: {
		name: 'Case Reference',
		componentType: 'autocomplete',
	},
	fileName: {
		name: 'Name of File Used',
		componentType: 'string',
	},
	wordListName: {
		name: 'Name of Word List Used',
		componentType: 'string',
	},
	uploadComplete: {
		name: 'Upload Completed',
		componentType: 'boolean',
	},
	processingComplete: {
		name: 'Processing Completed',
		componentType: 'boolean',
	},
};

export type MetricsFilterOptions = keyof MetricsFilters;

export interface ApiCustomDataRequest {
	disabledTabs: {
		changesMade: boolean;
		newData: string[];
	};
	updateNotice: {
		changesMade: boolean;
		title: string;
		desc: string[];
	};
	faqs: {
		changesMade: boolean;
		newData: {
			answer: string;
			question: string;
		}[];
	};
}
